import {Model} from "./Model";
import {IApiTeamMember, IApiGameAccount, IApiTeamMembership, IApiMembership} from "../typings/apiResponse";
import {User} from "./User";
import {Team} from "./Team";

/**
 * @ngdoc overview
 *
 * @type {Object}
 * @name ngLeague.TeamMember
 *
 * @requires apiResponse
 *
 * @description
 * The TeamMember object represents a team member on ESL Play.
 */
export class TeamMember extends Model {

    constructor(private apiResponse: IApiTeamMember) {
        super(apiResponse);
    }

    public getUser(): User {
        return new User(this.apiResponse.user);
    }

    public getMembership(): Membership {
        return new Membership(this.apiResponse.membership);
    }

    /**
     * Returns the game account of the user for a given key. This value is only set if the Teammember is
     * created from an API response with the embedGameaccount parameter set.
     *
     * @see ngLeague.TeamService#getTeamMembers
     *
     * @param key
     *
     * @returns {IApiGameAccount}
     */
    public getGameaccount(key: string): IApiGameAccount {
        if (this.apiResponse.gameaccounts) {
            return this.apiResponse.gameaccounts[key];
        }
    }
}


/**
 * @ngdoc overview
 *
 * @type {Object}
 * @name ngLeague.TeamMembership
 *
 * @requires apiResponse
 *
 * @description
 * The TeamMembership object contains a user's team and his relation to the team.
 */
export class TeamMembership extends Model {
    constructor(private apiResponse: IApiTeamMembership) {
        super(apiResponse);
    }

    public getTeam() {
        return new Team(this.apiResponse.team);
    }

    public getMembership() {
        return new Membership(this.apiResponse.membership);
    }
}

/**
 * @ngdoc overview
 *
 * @type {Object}
 * @name ngLeague.Membership
 *
 * @requires apiResponse
 *
 * @description
 * The Membership object represents a team membership relation on ESL Play.
 */
export class Membership extends Model {

    public static ROLE = {
        TEAM_OWNER: 'Team-Owner',
        TEAM_MANAGER: 'Team-Manager',
        TEAM_CAPTAIN: 'Team-Captain',
        ORGA: 'Orga',
        PLAYER: 'Player',
        TRIAL: 'Trial',
        HONORARY_MEMBER: 'Honorary member',
        INACTIVE: 'Inactive'
    };

    public static PERMISSION = {
        LEADER: 'leader',
        CO_LEADER: 'co-leader',
        MATCH_ORGA: 'matchorga',
        FIGHTER: 'fighter',
        TRIAL: 'trial'
    };

    constructor(private apiResponse: IApiMembership) {
        super(apiResponse);
    }

    public getRole() {
        return this.apiResponse.role;
    }

    public getPermission() {
        return this.apiResponse.permission;
    }
}